import React from "react";

import { Banner, ErrorHandler } from "ui/app";

import { TopNavigationBar } from "../top-navigation-bar";

import "./DefaultLayout.scss";

export const DefaultLayout: React.FC = ({ children }) => {
  return (
    <>
      <TopNavigationBar />
      <main>
        <ErrorHandler>
          <div className="content">
            <Banner useAppNotification={true} />
            {children}
          </div>
        </ErrorHandler>
      </main>
    </>
  );
};
